export const PAYMENT_METHOD_TYPE = {
  CARD: "card",
  KLARNA: "klarna",
  APPLE_PAY: "apple_pay",
} as const;

export const PAYMENT_ORIGIN = {
  ONBOARDING: "onboarding",
  SHOP: "shop",
} as const;

export const PAYMENT_STATUS = {
  FAILED: "failed",
  SUCCESS: "completed",
  PROCESSING: "processing",
} as const;

export const PAYMENT_REDIRECT_STATUS = {
  SUCCEEDED: "succeeded",
  FAILED: "failed",
} as const;
